import { DAYS_PER_WEEK } from "../shared";
import { FIRST_DAY } from "./calendar";

/**
 * The course is handed over a week at a time, so the week is what decides
 * which sheets exist, which ones print together, and where the upgrade notice
 * lands. Weeks are counted from the start date rather than from a Monday:
 * week 1 is always days 1 to 7 of the journey.
 */
export function getWeekNumber(day: number): number {
  return Math.max(1, Math.ceil(Math.max(FIRST_DAY, day) / DAYS_PER_WEEK));
}

export function getWeekStartDay(week: number): number {
  return (Math.max(1, week) - 1) * DAYS_PER_WEEK + FIRST_DAY;
}

export function getTotalWeeks(totalDays: number): number {
  return Math.max(1, Math.ceil(Math.max(0, totalDays) / DAYS_PER_WEEK));
}

/**
 * The days a week actually has. The last week of a journey is short whenever
 * the word count does not divide the pool into whole weeks.
 */
export function getWeekDays(week: number, totalDays: number): number[] {
  const start = getWeekStartDay(week);
  const end = Math.min(totalDays, start + DAYS_PER_WEEK - 1);
  if (end < start) return [];
  return Array.from({ length: end - start + 1 }, (_, offset) => start + offset);
}

/** A week arrives whole, the moment the calendar reaches its first day. */
export function isWeekReleased(week: number, currentDay: number): boolean {
  return currentDay >= getWeekStartDay(week);
}
